import type { NewsVersionType } from '@/api/generated/v2'


export type PublishedFilterConfiguratorType = 'codes' | 'feeds' | 'users' | 'presets'

export type NewsAction =
  | 'showNewsbreak'
  | 'deleteNews'
  | 'recall'
  | 'revoke'
  | 'changeLang'
  | 'authors'
  | 'editor'
  | 'showHistory'
  | 'showRelations'
  | 'sendToAsoi'
  | 'copyText'
  | 'forbiddenEntities'
  | 'close'

interface NewsActionItem {
  label: string
  key: NewsAction
}

export const newsAction: Record<NewsAction, NewsActionItem> = {
  revoke: {
    label: 'Аннулировать',
    key: 'revoke',
  },
  showHistory: {
    label: 'Посмотреть историю работы',
    key: 'showHistory',
  },
  showRelations: {
    label: 'Посмотреть связанные материалы',
    key: 'showRelations',
  },
  sendToAsoi: {
    label: 'Отправить в АСОИ',
    key: 'sendToAsoi',
  },
  deleteNews: {
    label: 'Удаление',
    key: 'deleteNews',
  },
  showNewsbreak: {
    label: 'Панель инфоповода',
    key: 'showNewsbreak',
  },
  recall: {
    label: 'Отозвать новость',
    key: 'recall',
  },
  changeLang: {
    label: 'Язык',
    key: 'changeLang',
  },
  authors: {
    label: 'Авторы',
    key: 'authors',
  },
  editor: {
    label: 'Редактор',
    key: 'editor',
  },
  copyText: {
    label: 'Копировать текст новости',
    key: 'copyText',
  },
  forbiddenEntities: {
    label: 'Разметить запрещённые сущности',
    key: 'forbiddenEntities',
  },
  close: {
    label: 'Закрытие панели',
    key: 'close',
  },
} as const

export type EntryType = 'newsItem' | 'newsbreak' | 'asoiNote' | 'thumb'

export interface EntryItem {
  id: number
  type: EntryType
  meta: string
  type_id?: NewsVersionType
  date?: string
  body?: string
  is_revoked?: boolean
  source?: string
}

export type RelationsEntryItem = {
  type: EntryType
  entry?: EntryItem
  isCurrent?: boolean
  hasHorizontalLine?: boolean
}
